import MultiPriceChart from './MultiPriceChart';

export default MultiPriceChart;
